import FormTypes from 'forms-utils-lib/constants/formDefinition/FormTypes';
export const Columns = {
  NAME: 'NAME',
  VIEWS: 'VIEWS',
  SUBMISSION_RATE: 'SUBMISSION_RATE',
  SUBMISSION_COUNT: 'SUBMISSION_COUNT',
  APPEARS_ON: 'APPEARS_ON',
  LAST_MODIFIED: 'LAST_MODIFIED',
  BUSINESS_UNIT: 'BUSINESS_UNIT'
};
export const ColumnNames = Object.keys(Columns);
export const ColumnLangKeys = {
  [Columns.NAME]: 'name',
  [Columns.VIEWS]: 'views',
  [Columns.SUBMISSION_RATE]: 'submissionRate',
  [Columns.SUBMISSION_COUNT]: 'submissionCount',
  [Columns.APPEARS_ON]: 'appearsOn',
  [Columns.LAST_MODIFIED]: 'lastModified',
  [Columns.BUSINESS_UNIT]: 'businessUnit'
};
export const SortDirections = {
  DESCENDING: 'DESCENDING',
  ASCENDING: 'ASCENDING'
};

// Keys for the reducer.
export const StateKeys = {
  FORM_ANALYTICS_DATE_RANGE: 'formAnalyticsDateRange',
  FORM_ANALYTICS_BUSINESS_UNIT_ID: 'formAnalyticsBusinessUnitId',
  FORM_ANALYTICS_SELECTED_FORMS: 'formAnalyticsSelectedForms',
  FORM_ANALYTICS_SEARCH_QUERY: 'formAnalyticsSearchQuery'
};
export const RowTypeKeys = {
  FORM: 'FORM',
  FOLDER: 'FOLDER'
};

// NOTE: if this is changed update earlyRequesterShared.
export const ALL_DASHBOARD_FORM_TYPES = [FormTypes.CAPTURED, FormTypes.HUBSPOT, FormTypes.FLOW,
// FormTypes.POPUP
FormTypes.BLOG_COMMENT, FormTypes.TICKET_FORM];
export const TABS = {
  MANAGE: 'manage',
  ANALYZE: 'analyze'
};